<script>
import substanceDictionaries from "@core/mixins/substance-dictionaries";
import { BCardTitle, BListGroup, BListGroupItem, BBadge, BFormRadio, BCard, BRow, BCol, BFormGroup, BButton,
    BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import { VueAutosuggest } from 'vue-autosuggest'
import {SubstanceLists} from "@/libs/substance";

export default {
    mixins: [substanceDictionaries],
    components: {
        BCard, BButton, BRow, BCol, BFormGroup, BCardTitle,
        BFormInput, VueAutosuggest, vSelect, BBadge, BFormRadio, Treeselect, BListGroup, BListGroupItem,
    },
    props: {
        readOnly: {
            default: false,
        },
        compactView: {
            default: false
        },
        concentrationRangeIntervalOptions: {
            default() {
                return [];
            }
        },
        isMaterialCategoryMandatory: {
            type: Boolean,
            default: true
        },
        substance: {
            required: true,
            type: Object,
        },
        substanceList: {
            required: true,
            type: Object,
        },
        details: {
            required: true,
            type: Array,
        }
    },
    data() {
        return {
            treeselectMandatoryClass: 'treeselect-bg-warning',
            maxConcentrationRange: this.getMaxConcentration(),
            concentrationRange: this.getConcentrationRange(),
            materialCategory: this.getMaterialCategory(),
            additionalMaterial: this.getAdditionalMaterial(),
            mixtureCategory: this.getMixtureCategory(),
            exemption: this.getExemption(),

            suggestions: [],
            searchTimer: null,
            inputProps: {
                class: 'form-control w-100',
            },
        };
    },
    methods: {
        getExemption() {
            return this.details.length ? this.details[0].exemption : [];
        },
        getAdditionalMaterial() {
            return this.details.filter(d => d.additionalMaterial && d.additionalMaterial.id).map(d => d.additionalMaterial);
        },
        getMixtureCategory() {
            return this.details.filter(d => d.mixtureCategory && d.mixtureCategory.id).map(d => d.mixtureCategory);
        },
        getMaterialCategory() {
            return this.details.filter(d => d.materialCategory && d.materialCategory.id).map(d => d.materialCategory);
        },
        getConcentrationRange() {
            let range = null;
            this.details
                .filter(d => d.concentrationRange && d.concentrationRange.id)
                .forEach(d => {
                    if (!range || range.priority < d.concentrationRange.priority) {
                        range = d.concentrationRange;
                    }
                });

            return range;
        },
        getMaxConcentration() {
            return Math.max(...this.details
                .filter(details => details.maxConcentration)
                .map(details => details.maxConcentration))
        },
        exclude(substance) {
            this.$emit('exclude', substance);
        },
        normalize(node) {
            return {id: node.id, label: node.title};
        },

        onMaterialCategoryChange(value) {
            this.materialCategory.push({
                id: value.id,
                title: value.title
            });
            this.emit();
        },

        onMaterialCategoryDeselect(value) {
            const index = this.materialCategory.findIndex(c => c.id === value.id);
            if (index >= 0) {
                this.materialCategory.splice(index, 1);
            }
            this.emit();
        },

        onExemptionSelect() {
            this.emit();
        },

        onMixtureCategoryChange(value) {
            this.mixtureCategory.push({
                id: value.id,
                title: value.title
            });
            this.emit();
        },

        onMixtureCategoryDeselect(value) {
            const index = this.mixtureCategory.findIndex(c => c.id === value.id);
            if (index >= 0) {
                this.mixtureCategory.splice(index, 1);
            }
            this.emit();
        },

        onAdditionalMaterialChange(value) {
            this.additionalMaterial = value;
            this.emit();
        },

        onMaxConcentrationRangeChange(value) {
            this.emit();
        },

        onConcentrationRangeChange(value) {
            this.concentrationRange = value;
            this.emit();
        },

        emit() {
            this.$emit('change', SubstanceLists.CANDIDATE_LIST, this.makeDetails());
        },

        makeDetails() {
            let maxConcentrationRange = null;
            if (this.maxConcentrationRange) {
                maxConcentrationRange = parseFloat(this.maxConcentrationRange)
            }
            let iterations = Math.max(
                this.additionalMaterial.length,
                this.materialCategory.length,
                this.mixtureCategory.length
            ) - 1;
            const materialCategories = this.materialCategory.map(c => {
                return {id: c.id, title: c.title};
            });
            const mixtureCategories = this.mixtureCategory.map(c => {
                return {id: c.id, title: c.title};
            });
            const additionalMaterial = this.additionalMaterial.map(c => {
                return {id: c.id, title: c.title};
            });

            const details = [{
                concentrationRange: this.concentrationRange,
                additionalMaterial: additionalMaterial.shift() || null,
                materialCategory: materialCategories.shift() || null,
                mixtureCategory: mixtureCategories.shift() || null,
                maxConcentration: maxConcentrationRange,
                exemption: this.exemption
            }];

            while (iterations > 0) {
                details.push({
                    concentrationRange: this.concentrationRange,
                    additionalMaterial: additionalMaterial.shift() || null,
                    materialCategory: materialCategories.shift() || null,
                    mixtureCategory: mixtureCategories.shift() || null,
                    maxConcentration: maxConcentrationRange
                })
                iterations--;
            }

            return details;
        }
    },
    created() {
        this.initSubstanceDictionaries();
    },
    computed: {
        materialCategoryMandatoryClass() {
            if (this.isMaterialCategoryMandatory) {
                return this.mixtureCategory ? '' : this.treeselectMandatoryClass;
            }

            return '';
        },
    },
    watch: {
        details() {
            this.maxConcentrationRange = this.getMaxConcentration();
            this.concentrationRange = this.getConcentrationRange();
            this.materialCategory = this.getMaterialCategory();
            this.additionalMaterial = this.getAdditionalMaterial();
            this.mixtureCategory = this.getMixtureCategory();
            this.exemption = this.getExemption();
        }
    }
}
</script>

<template>
    <div>
        <b-row v-if="compactView" class="pl-2 pr-2">
            <b-col>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):max-concentration')">
                            <b-form-input
                                :title="$t('Component(CompositionSubstance):hover-max-concentration')"
                                v-model="maxConcentrationRange"
                                type="number"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):rohs-exemption')">
                            <v-select
                                :taggable="true"
                                v-model="exemption"
                                multiple
                                :title="$t('Component(CompositionSubstance):rohs-exemption')"
                                :options="[]"
                                :placeholder="$t('Component(CompositionSubstance):rohs-exemption')"
                                :disabled="readOnly"
                                @input="onExemptionSelect"
                            >
                                <template v-slot:no-options="{ search, searching }">
                                    {{ $t('Component(CompositionSubstance):multi-exemption-no-options') }}
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):scip-interval')">
                            <v-select
                                v-model="concentrationRange"
                                label="title"
                                class="input-bg-warning"
                                :title="$t('Component(CompositionSubstance):hover-scip-interval')"
                                :options="concentrationRangeIntervalOptions"
                                @input="onConcentrationRangeChange"
                                :placeholder="$t('Component(CompositionSubstance):scip-interval-placeholder')"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                            <b-form-group :label="$t('Component(CompositionSubstance):mixture-category')">
                            <treeselect
                                @select="onMixtureCategoryChange"
                                @deselect="onMixtureCategoryDeselect"
                                :options="mixtureCategories"
                                :clearable="false"
                                :title="$t('Component(CompositionSubstance):hover-mixture-category')"
                                noChildrenText=""
                                valueFormat="object"
                                multiple
                                :normalizer="normalize"
                                :disabled="readOnly"
                                v-model="mixtureCategory"
                                :placeholder="$t('Component(CompositionSubstance):mixture-category-placeholder')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):material-category')">
                            <treeselect
                                @select="onMaterialCategoryChange"
                                @deselect="onMaterialCategoryDeselect"
                                :clearable="false"
                                :options="materialCategories"
                                :title="$t('Component(CompositionSubstance):hover-material-category')"
                                noChildrenText=""
                                :class="materialCategoryMandatoryClass"
                                valueFormat="object"
                                multiple
                                :normalizer="normalize"
                                v-model="materialCategory"
                                :disabled="readOnly"
                                :placeholder="$t('Component(CompositionSubstance):material-category-placeholder')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):additional-material')">
                            <v-select
                                v-model="additionalMaterial"
                                @input="onAdditionalMaterialChange"
                                label="title"
                                :title="$t('Component(CompositionSubstance):hover-additional-material')"
                                :getOptionLabel="(o) => o.title"
                                :options="additionalMaterials"
                                multiple
                                :disabled="readOnly"
                                :placeholder="$t('Component(CompositionSubstance):additional-material-placeholder')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-else class="pl-2 pr-2">
            <b-col md="5" lg="5">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):max-concentration')">
                            <b-form-input
                                v-model="maxConcentrationRange"
                                :title="$t('Component(CompositionSubstance):hover-max-concentration')"
                                type="number"
                                @input="onMaxConcentrationRangeChange"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):scip-interval')">
                            <v-select
                                v-model="concentrationRange"
                                label="title"
                                class="input-bg-warning"
                                :title="$t('Component(CompositionSubstance):hover-scip-interval')"
                                :options="concentrationRangeIntervalOptions"
                                @input="onConcentrationRangeChange"
                                :placeholder="$t('Component(CompositionSubstance):scip-interval-placeholder')"
                                :disabled="readOnly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):mixture-category')">
                            <treeselect
                                @select="onMixtureCategoryChange"
                                @deselect="onMixtureCategoryDeselect"
                                :options="mixtureCategories"
                                :clearable="false"
                                :title="$t('Component(CompositionSubstance):hover-mixture-category')"
                                noChildrenText=""
                                valueFormat="object"
                                multiple
                                :normalizer="normalize"
                                :disabled="readOnly"
                                v-model="mixtureCategory"
                                :placeholder="$t('Component(Placeholder):select-or-search')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="7" lg="7">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):rohs-exemption')">
                            <v-select
                                :taggable="true"
                                v-model="exemption"
                                multiple
                                :title="$t('Component(CompositionSubstance):rohs-exemption')"
                                :options="[]"
                                :placeholder="$t('Component(CompositionSubstance):rohs-exemption')"
                                :disabled="readOnly"
                                @input="onExemptionSelect"
                            >
                                <template v-slot:no-options="{ search, searching }">
                                    {{ $t('Component(CompositionSubstance):multi-exemption-no-options') }}
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):material-category')">
                            <treeselect
                                @select="onMaterialCategoryChange"
                                @deselect="onMaterialCategoryDeselect"
                                :options="materialCategories"
                                noChildrenText=""
                                :class="materialCategoryMandatoryClass"
                                valueFormat="object"
                                multiple
                                :clearable="false"
                                :title="$t('Component(CompositionSubstance):hover-material-category')"
                                :normalizer="normalize"
                                v-model="materialCategory"
                                :disabled="readOnly"
                                :placeholder="$t('Component(Placeholder):select-or-search')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):additional-material')">
                            <v-select
                                v-model="additionalMaterial"
                                @input="onAdditionalMaterialChange"
                                label="title"
                                :title="$t('Component(CompositionSubstance):hover-additional-material')"
                                :getOptionLabel="(o) => o.title"
                                :options="additionalMaterials"
                                multiple
                                :disabled="readOnly"
                                :placeholder="$t('Component(Placeholder):select-or-search')"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
